import React, { useState, useCallback, memo, MouseEventHandler } from 'react'
import { RegionsMenuWrapper, RegionsMenuHeader, RegionsMenuBackButton, RegionsMenuTitle } from './styles'
import { MegabarTransport } from '../../../transports/common/megabar-transport'
import { useTranslation } from '../../../hooks/locale'
import { BackIcon } from '../icons'
import RegionCountryItem from './region-country-item'

interface RegionsMenuProps {
    megabar: MegabarTransport
    onBack: MouseEventHandler<HTMLButtonElement>
}

const RegionsMenu: React.FC<RegionsMenuProps> = ({ megabar, onBack }) => {
    const { t } = useTranslation()
    const [expandedCountries, setExpandedCountries] = useState<Set<string>>(new Set())

    const _handleCountryToggle = useCallback((countryName: string) => {
        setExpandedCountries(prev => {
            const newSet = new Set(prev)
            if (newSet.has(countryName)) {
                newSet.delete(countryName)
            } else {
                newSet.add(countryName)
            }
            return newSet
        })
    }, [])

    return (
        <RegionsMenuWrapper>
            <RegionsMenuHeader>
                <RegionsMenuBackButton onClick={onBack}>
                    <BackIcon />
                </RegionsMenuBackButton>
                <RegionsMenuTitle>{t('regions')}</RegionsMenuTitle>
            </RegionsMenuHeader>

            {megabar.countries.map(country => (
                <RegionCountryItem
                    key={country.name}
                    country={country}
                    isExpanded={expandedCountries.has(country.name)}
                    onToggle={_handleCountryToggle}
                />
            ))}
        </RegionsMenuWrapper>
    )
}

export default memo(RegionsMenu)
